// Business calendar = US Central (the store is in Kansas). Use these instead of
// new Date().toISOString().split('T')[0], which gives the UTC date — "tomorrow"
// every evening after 7 PM Central.
export const BUSINESS_TZ = 'America/Chicago';

/** YYYY-MM-DD calendar date of `date` in US Central. */
export const toCentralDateString = (date = new Date()) =>
  date.toLocaleDateString('en-CA', { timeZone: BUSINESS_TZ });

/** Today's date (YYYY-MM-DD) in US Central. */
export const todayCentral = () => toCentralDateString(new Date());
